import {useEffect} from "react";

const ReturnPolicy = () => {

    useEffect(() => {
        window.scrollTo(10, 10)
    }, [])

    return (
        <div className="px-4 md:px-56 my-10 md:my-20">
            <h1 className="text-center font-bold text-3xl">ПОЛИТИКА
                ВОЗВРАТА И ОБМЕНА ПРОДУКТОВ ПИТАНИЯ</h1>
            <h3 className="font-bold text-2xl mt-4 text-center">1. Общие положения</h3>

            <p>
                <p><br/></p>  1.1. Настоящая Политика возврата и обмена продуктов питания (далее —
                «Политика») разработана в соответствии с требованиями Гражданского кодекса
                Республики Казахстан, Закона Республики Казахстан «О защите прав потребителей» и
                регулирует порядок возврата и обмена продуктов питания, приобретенных через
                Платформу DOM FOOD (ДОМ ФУД).
                <p><br/></p> 1.2. Настоящая Политика является неотъемлемой частью Пользовательского
                соглашения и применяется совместно с Соглашением о защите персональных данных
                пользователей, размещёнными на сайтах DOM FOOD по адресам: https://dom-food.com,
                https://domfood.kz.
                <p><br/></p>  1.3. Пользователь, осуществляя заказ через Платформу, подтверждает ознакомление
                с настоящей Политикой и соглашается с её условиями. Если Пользователь не согласен с
                условиями Политики, он обязан воздержаться от оформления заказов на Платформе.
                <p><br/></p>  1.4. Сбор и обработка персональных данных, необходимых для рассмотрения заявок
                на возврат или обмен (ФИО, контактные данные, история заказов и иные данные),
                осуществляется в соответствии с «Соглашением о защите персональных данных
                пользователей», доступным по адресу: https://dom-food.com/agreement_users.
                <p><br/></p>  1.5. Компания обязуется оперативно реагировать на все обращения Пользователей,
                связанные с возвратом и обменом продуктов питания.
            </p>

            <h3 className="font-bold text-2xl mt-4 text-center">2. Термины и определения</h3>
            <p>

                <p><br/></p>  2.1. В настоящей Политике применяются следующие термины и определения:
                <p><br/></p>  2.1.1. Платформа — веб-сайты https://dom-food.com и https://domfood.kz,
                мобильное приложение DOM FOOD и связанные с ними сервисы, предназначенные для
                взаимодействия Пользователей, Повара и Курьеров, а также для оформления и
                исполнения заказов;
                <p><br/></p>  2.1.2. Продукты питания — готовые блюда, безалкогольные напитки, мясные и
                иные пищевые продукты, полуфабрикаты, приготовленные или предложенные Поварами
                для продажи Пользователям через Платформу;
                <p><br/></p>  2.1.3. Покупатель — дееспособное физическое лицо, достигшее 18 лет,
                присоединившееся к Пользовательскому соглашению в собственном интересе либо
                юридическое лицо в лице своего представителя, выступающего от имени и в интересах
                представляемого им юридического лица, которые оформляют заказы на товары и услуги
                через онлайн Платформу;
                <p><br/></p>   2.1.4. Администратор Платформы/Администратор — юридическое лицо,
                обеспечивающее техническую поддержку и функционирование Платформы. В рамках
                настоящей Политики Администратором является: Общество с ограниченной
                ответственностью DOM FOOD «ДОМ ФУД», юридическое лицо, созданное по
                законодательству Республики Армения и зарегистрированное по адресу: Республика
                Армения, город Ереван, ул. Чайковского, дом 34, квартира 19. Кентрон, 0010, а также
                Товарищество с ограниченной ответственностью «DOM FOOD (ДОМ ФУД)», БИН
                240940031813, зарегистрированное по законодательству Республики Казахстан,
                местонахождения: Республика Казахстан, город Астана, район Байконыр, улица
                Амангелді Иманов, здание 19, офис 78, почтовый индекс 010000;
                <p><br/></p>  2.1.5. Повар — ресторан, розничный магазин, индивидуальный повар или иное
                лицо, заключившее Поварское соглашение с Администратором и предлагающее в
                качестве продавца свои Продукты питания (в том числе готовую еду, напитки,
                полуфабрикаты). Повар может самостоятельно доставлять Продукты питания либо
                использовать услуги Курьеров, работающих на основе отдельного Курьерского
                соглашения;
                <p><br/></p>  2.1.6. Курьер — физическое или юридическое лицо, заключившее Курьерское
                соглашение с Администратором и оказывающее услуги по доставке Продуктов питания
                от Повара до Покупателя с использованием интерфейсов Платформы;
                <p><br/></p>  2.1.7. Пользовательское соглашение — документ, определяющий условия
                использования Платформы, размещённый на сайтах DOM FOOD, с которым обязаны
                согласиться все Пользователи при регистрации и оформлении заказов.
            </p>
            <h3 className="font-bold text-2xl mt-4 text-center">3. Условия возврата и обмена Продуктов питания</h3>
            <p>
                <p><br/></p>  3.1. Продукты питания, приобретённые через Платформу, подлежат возврату или
                обмену в следующих случаях:
                <p><br/></p>  3.1.1. Обнаружение Покупателем недостатков, существенно влияющих на
                качество Продуктов питания, таких как порча, посторонние включения, несоответствие
                заявленному составу или описанию, нарушение упаковки и санитарных норм;
                <p><br/></p> 3.1.2. Истечение срока годности Продуктов питания на момент их получения
                Покупателем.
                <p><br/></p>  3.2. Возврат или обмен возможен при одновременном соблюдении следующих
                условий:
                <p><br/></p>  3.2.1. Покупатель направляет через Платформу заявление о возврате или обмене
                с указанием причины возврата, фотофиксацией недостатков (при возможности) и
                подтверждением даты и времени получения заказа;
                <p><br/></p>  3.2.2. Продукты питания не были употреблены и сохранили товарный вид
                (возможность визуального осмотра), упаковка не нарушена по вине Покупателя;
                <p><br/></p>  3.2.3. Сохранена оригинальная упаковка, пломбы и маркировка (если
                применимо), предоставленные Поваром, в случае если такая упаковка предусматривалась
                при передаче Продукта питания;
                <p><br/></p>  3.2.4. Покупателем представлены документы, подтверждающие факт покупки
                (электронный или кассовый чек, запись в личном кабинете Платформы и иные
                допустимые доказательства).
                <p><br/></p>   3.3. Порядок замены Продуктов питания:
                <p><br/></p>  3.3.1. Повар обязан произвести замену товара незамедлительно после
                подтверждения недостатков;
                <p><br/></p>  3.3.2. Если необходима дополнительная проверка или экспертиза качества
                Продуктов питания, замена осуществляется в течение 30 календарных дней с даты
                получения претензии;
                <p><br/></p>  3.3.3. Если у Повара отсутствуют необходимые для замены Продукты питания, он
                обязан произвести замену в течение 10 календарных дней с даты обращения Покупателя.
                <p><br/></p>  3.4. Индивидуально изготовленные Продукты питания (например, с учётом
                диетических требований или предпочтений Покупателя) возврату или обмену не
                подлежат, если соответствуют заявленным требованиям и не имеют признаков
                ненадлежащего качества.
                <p><br/></p>  3.5. Покупатель обязан проверить товар на комплектность, внешний вид,
                количество и соответствие заявленному при получении заказа. Претензии по этим
                параметрам принимаются только непосредственно в момент передачи товара курьером
                или при самовывозе.
                <p><br/></p>  3.6. Место возврата или обмена Продуктов питания согласовывается Покупателем и
                Поваром индивидуально и может быть осуществлено либо по адресу нахождения Повара,
                либо посредством курьерской службы.
                <p><br/></p>  3.7. Продукты питания относятся к категории быстро портящихся товаров. Возврат
                и обмен Продуктов питания надлежащего качества не осуществляется в соответствии с
                законодательством Республики Казахстан.
                <p><br/></p>   3.8. При подаче претензии, связанной с ухудшением здоровья Покупателя
                (например, пищевое отравление), Администратор и/или Повар вправе запросить
                следующие документы и сведения: медицинскую справку или заключение врача,
                фотографии продукта, описание симптомов и указание времени употребления продукта.
                Указанные сведения используются исключительно для проверки обоснованности
                претензии и, при необходимости, могут быть переданы компетентным органам или иным
                уполномоченным лицам в соответствии с законодательством Республики Казахстан.
                <p><br/></p>  3.9. При отсутствии достаточных доказательств (включая фото, видео, медицинские
                справки, подтверждающие документы) Администратор и/или Повар вправе отказать в
                удовлетворении претензии, связанной с возвратом или обменом Продуктов питания.
                <p><br/></p>  3.10. В случае неоднократных и необоснованных обращений с требованиями
                возврата или обмена Администратор оставляет за собой право приостановить или
                ограничить доступ Пользователя к использованию Платформы.
            </p>

            <h3 className="font-bold text-2xl mt-4 text-center">4. Порядок возврата денежных средств</h3>
            <p>
                <p><br/></p>  4.1. В случае удовлетворения требования о возврате Продуктов питания
                Покупателю возвращается полная стоимость соответствующего товара.
                <p><br/></p>  4.2. Возврат денежных средств осуществляется тем же способом, которым была
                произведена оплата заказа (на банковскую карту, расчётный счёт или иным способом,
                использованным при оплате), в течение 10 (десяти) рабочих дней после получения
                Поваром возвращённых Продуктов питания и проверки их состояния.
                <p><br/></p> 4.3. При обмене Продуктов питания на аналогичные товары с отличающейся
                стоимостью применяется следующий порядок перерасчёта:
                <p><br/></p> 4.3.1. Если цена нового товара выше первоначального, Покупатель обязан
                оплатить разницу;
                <p><br/></p>  4.3.2. Если цена нового товара ниже первоначального, разница возвращается
                Покупателю тем же способом, которым производилась первоначальная оплата, в течение
                10 (десяти) рабочих дней с момента осуществления обмена.
                <p><br/></p>  4.4. Расходы, связанные с возвратом или обменом Продуктов питания
                ненадлежащего качества, возлагаются на Повара.
                <p><br/></p>   4.5. Администратор не компенсирует Пользователю косвенные убытки, упущенную
                выгоду, моральный вред или иные непрямые последствия, возникшие в результате
                ненадлежащего исполнения обязательств со стороны Повара.
            </p>
            <h3 className="font-bold text-2xl mt-4 text-center">5. Порядок урегулирования споров</h3>
            <p>
                <p><br/></p> 5.1. Все споры и разногласия, возникающие между Покупателем, Поваром и/или
                Администратором в связи с возвратом или обменом Продуктов питания, подлежат
                разрешению путём переговоров и в обязательном претензионном порядке.
                <p><br/></p> 5.2. Претензия может быть направлена Покупателем через функционал Платформы
                либо на адрес электронной почты Администратора: support@dom-food.com, с указанием
                следующей информации:
                <p><br/></p>5.2.1. номер и дату заказа;
                <p><br/></p>5.2.2. суть претензии и подробное описание ситуации;
                <p><br/></p> 5.2.3. подтверждающие материалы (фотографии, видео, справка — при наличии);
                <p><br/></p> 5.2.4. актуальные контактные данные Покупателя.
                <p><br/></p> 5.3. Администратор и/или Повар обязаны рассмотреть претензию в течение 10
                (десяти) рабочих дней с даты её получения и направить письменный ответ Покупателю
                через Платформу или по электронной почте.
                <p><br/></p> 5.4. В случае невозможности разрешения спора путём переговоров, а также при
                отсутствии ответа на претензию в установленный срок, все споры подлежат
                рассмотрению в Специализированном межрайонном экономическом суде города Астаны,
                если иное не предусмотрено законодательством Республики Казахстан.
                <p><br/></p> 5.5. До обращения в суд стороны обязуются предпринять все разумные меры по
                урегулированию спора в досудебном порядке.
            </p>
            <h3 className="font-bold text-2xl mt-4 text-center">6. Форс-мажорные обстоятельства</h3>
            <p>
                <p><br/></p> 6.1. Стороны освобождаются от ответственности за полное или частичное
                неисполнение обязательств по настоящей Политике, если оно стало следствием
                обстоятельств непреодолимой силы (форс-мажора), возникших после оформления заказа
                и не поддающихся разумному контролю сторон.
                <p><br/></p> 6.2. К форс-мажорным обстоятельствам, в частности, относятся:
                <p><br/></p> 6.2.1. стихийные бедствия (землетрясения, наводнения, ураганы и иные
                природные катаклизмы);
                <p><br/></p> 6.2.2. пожары, взрывы, аварии, техногенные катастрофы;
                <p><br/></p>  6.2.3. военные действия, мобилизация, массовые беспорядки, акты терроризма;
                <p><br/></p> 6.2.4. действия или акты государственных органов (включая введение
                чрезвычайного положения, блокировку транспортных или логистических маршрутов,
                ограничения на финансовые операции);
                <p><br/></p> 6.2.5. сбои в работе платформ, коммуникационных систем, сетей
                электроснабжения или иных технических систем, необходимых для исполнения
                обязательств по настоящей Политике.
                <p><br/></p> 6.3. Сторона, на которую повлияли обстоятельства форс-мажора, обязана уведомить
                об этом другую сторону в течение 3 (трёх) рабочих дней с момента их наступления,
                используя Платформу либо электронную почту.
                <p><br/></p>  6.4. Если обстоятельства непреодолимой силы продолжаются более 30 (тридцати)
                календарных дней, любая из сторон вправе прекратить обязательства по настоящей
                Политике, уведомив об этом другую сторону. В этом случае стороны обязуются
                произвести взаиморасчёты за фактически оказанные услуги или исполненные
                обязательства.
            </p>
            <h3 className="font-bold text-2xl mt-4 text-center">7. Заключительные положения</h3>
            <p>
                <p><br/></p> 7.1. Настоящая Политика является неотъемлемой частью Пользовательского
                соглашения и применяется ко всем заказам, оформленным через Платформу DOM FOOD,
                вне зависимости от того, подписана ли она в бумажной форме.
                <p><br/></p> 7.2. Актуальная версия Политики доступна на Платформе по адресам: https://domfood.com и https://domfood.kz.
                <p><br/></p> 7.3. Администратор оставляет за собой право вносить изменения в настоящую
                Политику в одностороннем порядке. Обновлённая редакция вступает в силу с момента её
                публикации на Платформе, если иное не указано в тексте изменений.
                <p><br/></p>7.4. Пользователь обязан самостоятельно отслеживать актуальные условия
                Политики. Продолжение использования Платформы после публикации обновлённой
                редакции считается согласием с её условиями.
                <p><br/></p>7.5. Недействительность одного из положений настоящей Политики не влечёт
                недействительность остальных положений. В случае признания какого-либо положения
                недействительным, оно подлежит замене положением, максимально приближённым по
                смыслу и цели.
                <p><br/></p> 7.6. Все условия настоящей Политики применяются в той мере, в какой это не
                противоречит действующему законодательству Республики Казахстан.
                <p><br/></p> 7.7. Администратор не является стороной договора купли-продажи между
                Пользователем и Поваром. Вся ответственность за качество, безопасность, состав и
                соответствие Продуктов питания требованиям законодательства несёт Повар как
                продавец. Администратор предоставляет только техническую платформу для
                взаимодействия сторон и не осуществляет контроль за деятельностью Поваров.
            </p>
            <h3 className="font-bold text-2xl mt-4 text-center">8. Контактная информация и реквизиты</h3>
            <p>
                <p><br/></p> 8.1. Наименование юридического лица: Товарищество с ограниченной
                ответственностью «DOM FOOD (ДОМ ФУД)».
                <p><br/></p> 8.2. БИН: 240940031813.
                <p><br/></p> 8.3. Юридический адрес: Республика Казахстан, город Астана, район Байконыр,
                улица Амангельдi Иманов, дом 19, офис 78, почтовый индекс 010000.
                <p><br/></p> 8.4. Электронная почта: support@dom-food.com.
                <p><br/></p> 8.5. Веб-сайты: https://dom-food.com и https://domfood.kz.
            </p>
        </div>
    )
}

export default ReturnPolicy;
